import { inject, Injectable } from '@angular/core';
import { UserRole } from '../models/user.model';
import { AuthService } from './auth.service';
import { ProjectService } from './project.service';
import { Router } from '@angular/router';

/**
 * Serviço responsável pelo redirecionamento do usuário após autenticação.
 * Avalia o perfil, role e status do usuário para determinar a rota de destino.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthRedirectService {
  readonly authService = inject(AuthService);
  readonly projectService = inject(ProjectService);
  readonly router = inject(Router);

  /**
   * Redireciona o usuário para a rota correta após o login com base no seu perfil e estado.
   * Administradores e usuários ativos são enviados à listagem de projetos.
   * Tomadores de crédito inativos são redirecionados para criação ou confirmação de projeto.
   *
   * @returns Promise resolvida após a navegação ser iniciada
   */
  async redirectAfterLogin(): Promise<void> {
    const user = this.authService.currentUser();

    if (!user) {
      this.router.navigate(['/login']);
      return;
    }

    const isAdminLike = user.role === UserRole.Admin || user.role === UserRole.Super;
    const isTomadorCredito = user.role === UserRole.TomadorCredito;

    // Admin ou usuários ativos - área normal de projetos
    if (isAdminLike || !isTomadorCredito) {
      this.router.navigate(['/projects']);
      return;
    }

    // Usuários tomadores de crédito ativos - área de projetos
    if (isTomadorCredito) {
      this.router.navigate(['/projects']);
      return;
    }

    this.router.navigate(['/projects']);
  }
}
